import { Card, Form, message, Space, Table } from "antd";
import React, { useEffect, useState } from "react";

import { useNavigate, useParams } from "react-router-dom";
import { API } from "../../config/api";
import { POST } from "../../utils/apicalls";
import PageHeader from "../../admin/pageHeader/pageheader";

function TelecallerTaskDetails() {
  const [isLoading, setIsLoading] = useState(false);
  const [TaskData, setTaskData] = useState<any>();
  const [meta, setMeta] = useState<any>({});
  const { id } = useParams();

  useEffect(() => {
    viewTaskData();
  }, []);

  const viewTaskData = async () => {
    try {
      setIsLoading(true);
      let obj = {
        query: "string",
        page: 1,
        take: 5,
        Projectid: Number(id),
      };
      const url = API.TASK_IN_PROJECT;
      const response: any = await POST(url, obj);
      setTaskData(response?.data);
      setMeta(response?.meta);
    } catch (error) {
      console.error(error);
      message.error("Failed to fetch task data. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const navigate = useNavigate();
  const columns = [
    {
      dataIndex: "TaskName",
      title: "Task Name",
    },
    {
      dataIndex: "descriptions",
      title: "Description",
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (status: any) => {
        let color = "";

        // Assign colors based on the status value
        switch (status?.toLowerCase()) {
          case "completed":
            color = "green";
            break;
          case "pending":
            color = "orange";
            break;
          case "in-progress":
            color = "purple";
            break;
          default:
            color = "black"; // Default color
        }
        return <span style={{ color, fontWeight: "bold" }}>{status}</span>;
      },
    },
    {
      dataIndex: "hourss",
      title: "hours",
    },
    {
      dataIndex: "minituess",
      title: "minitues",
    },
  ];

  return (
    <div>
      <PageHeader />
      <Card>
        <h1 style={{ textAlign: "center" }}> TOTAL TASK: {TaskData?.length}</h1>{" "}
        <Table
          columns={columns}
          dataSource={TaskData} // Safe fallback
        // pagination={props?.pagination}
        // rowKey={(record: any) => record.id}
        />
      </Card>
    </div>
  );
}

export default TelecallerTaskDetails;
